// Loại hóa đơn
export default {
    NoInvoice: 0,
    NormalInvoice: 1,
    InvoiceGTGT: 2,
};